<template>
  <l-popup 
    :options="{
      offset,
      className: 'leaflet-custom-popup',
      offset,
      ...options
    }"
  >
    <slot />
  </l-popup>
</template>

<script>
import * as Vue2Leaflet from 'vue2-leaflet'
export default {
  name: 'c-map-popup-car',
  components: {
    'l-popup': Vue2Leaflet.LPopup,
  },
  props: {
    options: {
      type: Object,
      default() {
        return {}
      }
    },
    offset: {
      type: Array,
      default() {
        return [145, 210]
      }
    }
  }
}
</script>

<style lang="scss">
  .leaflet-custom-popup {
    .leaflet-popup-content-wrapper, 
    .leaflet-popup-tip {
      box-shadow: 0px 1px 5px rgba(82, 82, 82, 0.3);
    }
    .leaflet-popup-tip-container {
      left: -30px;
      margin-left: 0;
      overflow: hidden;
      pointer-events: none;
      transform: rotate(90deg);
      top: 8px;
    }
    .leaflet-popup-tip {
      width: 8px;
      height: 15px;
    }
    a.leaflet-popup-close-button {
      padding: 6px 8px 0 0 !important;
    }
    .leaflet-popup-content {
      margin: 10px;
    }
  }
</style>